import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import Joyride from 'react-joyride';
import PageLoading from '../common/componentsV2/elements/PageLoading';
import {
  addQuoteToCart,
  professionQuotesGetQuotes,
  professionQuotesSilentGetQuotes,
  removeQuoteFromCart,
  resetProfessionQuotes,
} from '../features/insuranceRequests/insuranceRequestsActions';
import { confirmAlert, generalAlertError } from '../common/utils/alerts';
import { ProfessionQuotesStyles } from './RcProfessionQuotes.styles';
import { EstimateContainer } from '../common/components/redesignComponents/common/Redesign.styles';
// import { useTourContext } from '../context/useTourContext';
import ErrorComponent from '../common/components/ErrorComponent';
// import { joyrideOptions } from '../common/utils/joyrideUtils';
// import { handleCallbackRcProfessionQuotes } from '../common/utils/joyrideCallbacks';
// import { rcProfessionQuotesSteps } from '../common/utils/joyrideSteps';
import {
  RiskButton,
  RiskButtonRemove,
  RiskCard,
  RiskContainer,
  SelectFirstNotice,
  SelectQuotePlaceholder,
} from '../common/components/redesignComponents/ResultPageComponents/v2/ResultSlotCard.styles';
import ProcessingQuoteSelectedProfession from '../common/components/redesignComponents/ResultPageComponents/ProcessingQuoteSelectedProfession';
import TutelaSelectedProfession from '../common/components/redesignComponents/ResultPageComponents/TutelaSelectedProfession';
import ProfessionModal from '../common/components/redesignComponents/ResultPageComponents/ProfessionModal';
import ConversationModal from '../common/components/redesignComponents/Modal/ConversationModal';
import { primaQuoteTypes } from '../common/constants';
import { V2FontImport } from '../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import ProfessionSummaryCard from '../common/components/redesignComponents/ResultPageComponents/v2/ProfessionSummaryCard';
import QuoteCostSummaryCard from '../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import FailedQuotationsComponent from '../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

const docs = {
  1: 'questionario_hcc_ingegneri.pdf',
  2: 'questionario_hcc_architetto.pdf',
  3: 'questionario_hcc_avvocato.pdf',
  4: 'questionario_hcc_Commercialista.pdf',
  5: 'questionario_hcc_consulente_del_lavoro.pdf',
  6: 'questionario_hcc_agente_immobiliare.pdf',
  7: 'questionario_hcc_agenti_di_attivita_finanziaria.pdf',
  8: 'questionario_hcc_amministratore_condominio.pdf',
  9: 'questionario_hcc_geometri.pdf',
  10: 'questionario_hcc_mediatore_creditizi.pdf',
  11: 'questionario_hcc_periti.pdf',
  12: 'questionario_hcc_tributarista.pdf',
  13: '',
  14: 'questionario_hcc_ag_commercio.pdf',
  15: 'questionario_hcc_agronomi.pdf',
  16: 'questionario_hcc_societa_di_edp.pdf',
  17: 'questionario_hcc_chimichi.pdf',
  18: 'questionario_hcc_dpo.pdf',
  19: 'questionario_hcc_geologi.pdf',
  20: 'questionario_hcc_miscellaneous.pdf',
  21: 'questionario_hcc_miscellaneous_energetica.pdf',
  22: 'questionario_hcc_psicologo.pdf',
  23: 'questionario_hcc_revisore_legale_dei_conti.pdf',
  24: 'questionario_hcc_singolo_componente_mediazione.pdf',
  25: 'questionario_hcc_tecnologo_alimentare.pdf',
  26: 'questionario_hcc_conformita.pdf',
};

const set_informativi = {
  1: 'set_informativo_hcc_ingegneri.pdf',
  2: 'set_informativo_hcc_architetto.pdf',
  3: 'set_informativo_hcc_avvocato.pdf',
  4: 'set_informativo_hcc_Commercialista.pdf',
  5: 'set_informativo_hcc_consulente_del_lavoro.pdf',
  6: 'set_informativo_hcc_agente_immobiliare.pdf',
  7: 'set_informativo_hcc_agenti_di_attivita_finanziaria.pdf',
  8: 'set_informativo_hcc_amministratore_condominio.pdf',
  9: 'set_informativo_hcc_geometri.pdf',
  10: 'set_informativo_hcc_mediatore_creditizi.pdf',
  11: 'set_informativo_hcc_periti.pdf',
  12: 'set_informativo_hcc_tributarista.pdf',
  13: '',
  14: 'set_informativo_hcc_ag_commercio.pdf',
  15: 'set_informativo_hcc_agronomi.pdf',
  16: 'set_informativo_hcc_societa_di_edp.pdf',
  17: 'set_informativo_hcc_chimichi.pdf',
  18: 'set_informativo_hcc_dpo.pdf',
  19: 'set_informativo_hcc_geologi.pdf',
  20: 'set_informativo_hcc_miscellaneous.pdf',
  21: 'set_informativo_hcc_miscellaneous_energetica.pdf',
  22: 'set_informativo_hcc_psicologo.pdf',
  23: 'set_informativo_hcc_revisore_legale_dei_conti.pdf',
  24: '',
  // "24": "set_informativo_hcc_singolo_componente_mediazione.pdf",
  25: 'set_informativo_hcc_tecnologo_alimentare.pdf',
  26: 'set_informativo_hcc_conformita.pdf',
};

const selectableExtensions = ['tlb', 'tls', 'tlg'];

export default function RcProfessionQuotes() {
  const navigate = useNavigate();
  const { requestToken } = useParams();
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);
  const [showConversationModal, setShowConversationModal] = useState(false);

  const state = useSelector(
    (store) => store.insuranceRequests.profession_quotes,
  );
  const {
    loading,
    failedQuotes,
    extensions,
    userData,
    profession,
    customer,
    quotations,
    addingQuote,
    processingQuote,
    riskQuotations,
    error,
    thread,
    est_provvigioni,
  } = state;

  // const [showSellingDistanceModal, setShowSellingDistanceModal] = useState(false);

  const refresh = () => professionQuotesGetQuotes(requestToken);
  const silentRefresh = () => professionQuotesSilentGetQuotes(requestToken);

  // const [steps, setSteps] = useState([]);

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('quoteNewResult') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('quoteNewResult')]);

  const fetchQuotes = () => {
    professionQuotesGetQuotes(requestToken);
  };

  const modifyData = () => {
    navigate('/quote/profession', {
      state: { requestToken },
    });
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addQuoteToCart(quoteId, fetchQuotes, modifyData));
  };

  // const firePurchaseTour = () => {
  //   localStorage.removeItem('quoteNewResult');
  //   setState({ run: true });
  // };

  useEffect(() => {
    professionQuotesGetQuotes(requestToken);

    return () => {
      resetProfessionQuotes();
    };
  }, []);

  // useEffect(() => {
  //   if (userData && userData.is_expired === true && userData.request_token === requestToken) {
  //     navigate('/quote/profession', {
  //       state: { requestToken },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [userData, requestToken]);

  // useEffect(() => {
  //   rcProfessionQuotesSteps(quotations, setSteps);
  // }, [quotations]);

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  // const getSellingDistanceLink = () => `${SELLING_DISTANCE_URL}/request/${distance_token}/professions/results`;

  // const copySellingDistanceLink = async () => {
  //   const link = getSellingDistanceLink();

  //   await navigator.clipboard.writeText(link);
  //   generalAlertSuccess('Il collegamento e stato copiato');
  // };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeQuoteFromCart(quoteId, fetchQuotes, modifyData));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }
    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    const total = quoteInProccessAmount + risksTotalAmount;
    return total.toFixed(2);
  };

  const handleRequestPurchase = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    navigate(`/quotes/profession/purchase/${requestToken}`);
  };

  return (
    <>
      {/* <Joyride
        steps={steps}
        run={run}
        continuous
        showBeacon={showBeacon}
        locale={{
          back: 'Indietro',
          close: 'Chiudi',
          last: 'Fine',
          next: 'Prossima',
          open: 'Apri il modale',
          restart: 'Riavvia il tour ',
          skip: 'Salta',
        }}
        styles={{
          options: joyrideOptions,
          buttonNext: {
            backgroundColor: '#00a651',
            outline: 'none',
          },
          buttonBack: {
            color: '#00a651',
            outline: 'none',
          },
          beaconInner: {
            backgroundColor: '#00a651',
          },
          beaconOuter: {
            borderColor: '#00a651',
            backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
          },
          buttonSkip: {
            outline: 'none',
          },
          buttonClose: {
            outline: 'none',
          },
        }}
        callback={(data) => handleCallbackRcProfessionQuotes(data, steps, setState)}
        showSkipButton
        showProgress
        disableScrolling
      /> */}
      {/* {openModal && <GuaranteesModalProfession setOpenModal={setOpenModal} profession={profession} extensions={extensions} requestToken={requestToken} selectableExtensions={selectableExtensions} />} */}

      {showConversationModal && (
        <ConversationModal
          requestId={userData?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_profession_result"
        />
      )}

      <V2FontImport />
      <ProfessionQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <ProfessionSummaryCard
              insuranceRequest={userData}
              customer={customer}
              modificaDati={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestPurchase()}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          {/* <GuaranteesDefaultState setShowGuaranteesModal={setOpenModal} quotes={userData.quotations} extensions={extensions} extension_price={profession.extension_price} /> */}
          <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end">
                  <div>
                    <OutlineActionButton
                      type="button"
                      onClick={() => {
                        setShowConversationModal(true);
                        if (thread?.unreadMessages > 0) silentRefresh();
                      }}
                    >
                      <ChatIcon />
                      Contatta il Backoffice
                      {thread?.unreadMessages > 0 && (
                        <ActionButtonBadge>
                          {thread.unreadMessages}
                          <span className="visually-hidden">messaggi non letti</span>
                        </ActionButtonBadge>
                      )}
                    </OutlineActionButton>
                    {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>

          {quotations && !quotations.res_civile
            && (
              <div className="alert alert-info mx-2" role="alert">
                <h4 className="alert-heading">Avviso!</h4>
                <p className="m-0">Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </div>
            )}

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-profession-third-step">
                  {quoteTypes.filter((t) => {
                    if (processingQuote !== null && processingQuote.company_id === 1002) {
                      return t.id !== 'tutela_legale';
                    }

                    if (processingQuote !== null && processingQuote.company_id === 4) {
                      return t.id === 'tutela_legale' || t.id === 'res_civile';
                    }

                    return t;
                  }).map((type, index) => (
                    <React.Fragment key={index}>
                      {quotations && quotations[type.id] && (
                        <RiskCard
                          className={`mt-3 purchase-quote-fourth-step flex-grow-1 d-flex align-items-center justify-content-between flex-column p-3 ${userData.processing_quotation_id === null
                            && type.id !== 'res_civile'
                            ? 'bg-secondary bg-opacity-25'
                            : ''
                          } ${userData.processing_quotation_id !== null
                              && type.id === 'res_civile'
                            ? 'bg-success bg-opacity-25'
                            : ''
                          } ${riskQuotations && riskQuotations[type.id] !== undefined
                            ? 'bg-success bg-opacity-25'
                            : ''
                          }`}
                        >
                          <div className="me-auto">
                            <h5>{type.name}</h5>
                          </div>
                          {processingQuote !== null && type.id === 'res_civile' && (
                            <ProcessingQuoteSelectedProfession
                              processingQuote={processingQuote}
                              requestInfo={userData}
                              refresh={refresh}
                              profession={profession}
                              set_informativi={set_informativi}
                              extensions={extensions}
                              requestToken={requestToken}
                              selectableExtensions={selectableExtensions}
                              docs={docs}
                            />
                          )}

                          {riskQuotations
                            && riskQuotations[type.id] !== undefined
                            && riskQuotations[type.id].map((quote, idx) => (
                              <React.Fragment key={idx}>
                                {processingQuote !== null
                                  && processingQuote.company_id !== 2
                                  && type.id === quote.quote_type && (
                                    <TutelaSelectedProfession
                                      tutelaLegaleQuote={quote}
                                      type={type}
                                      professionId={profession?.profession}
                                    />
                                )}
                              </React.Fragment>
                            ))}

                          {riskQuotations
                            && riskQuotations[type.id] === undefined
                            && type.id !== 'res_civile'
                            && processingQuote !== null && (
                              <SelectQuotePlaceholder
                                data-bs-toggle="modal"
                                data-bs-target={`#${type.id}`}
                              >
                                Seleziona Quotazione!
                              </SelectQuotePlaceholder>
                          )}

                          <div className="d-flex justify-content-end ms-auto gap-2">
                            {riskQuotations
                              && riskQuotations[type.id] !== undefined
                              && type.id !== 'res_civile'
                              && riskQuotations[type.id].map((quote, idx) => (
                                <React.Fragment key={idx}>
                                  {type.id === quote.quote_type && (
                                    <RiskButtonRemove
                                      className="btn btn-danger"
                                      onClick={() => removeItemFromCart(quote.id)}
                                    >
                                      Rimuovi
                                    </RiskButtonRemove>
                                  )}
                                </React.Fragment>
                              ))}

                            {riskQuotations
                              && riskQuotations[type.id] === undefined
                              && processingQuote !== null
                              && type.id !== 'res_civile' && (
                                <RiskButton
                                  className="btn btn-success"
                                  data-bs-toggle="modal"
                                  data-bs-target={`#${type.id}`}
                                >
                                  Aggiungi
                                </RiskButton>
                            )}

                            {type.id === 'res_civile' && processingQuote !== null && (
                              <RiskButtonRemove
                                className="btn btn-danger"
                                onClick={() => removeItemFromCart(processingQuote.id)}
                              >
                                Rimuovi
                              </RiskButtonRemove>
                            )}

                            {userData.processing_quotation_id === null
                              && type.id !== 'res_civile' && (
                                <SelectFirstNotice>
                                  Seleziona Prima La Responsibilita Civile
                                </SelectFirstNotice>
                            )}

                            {type.id === 'res_civile' && (
                              <RiskButton
                                className="btn btn-success"
                                data-bs-toggle="modal"
                                data-bs-target={`#${type.id}`}
                              >
                                Aggiungi
                              </RiskButton>
                            )}
                          </div>
                        </RiskCard>
                      )}
                    </React.Fragment>
                  ))}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <ProfessionModal
                    key={index}
                    type={type}
                    addingQuote={addingQuote}
                    quotations={quotations}
                    userData={userData}
                    profession={profession}
                    extensions={extensions}
                    requestToken={requestToken}
                    selectableExtensions={selectableExtensions}
                    docs={docs}
                    set_informativi={set_informativi}
                    selectQuotation={selectQuotation}
                  />
                ))}
              </>
            )}

          {failedQuotes !== null && failedQuotes.length > 0 && (
            <FailedQuotationsComponent failedQuotes={failedQuotes} />
          )}
        </div>

      </ProfessionQuotesStyles>
    </>
  );
}
